import React from "react";
import { Checkbox } from "antd";

export const CheckBoxForm = (props) => {
  return (
    <Checkbox
      checked={props.value}
      onChange={(value) => {
        if (props.field === "is_self_drive") {
          props.onChangeEnableForm(value.target.checked);
        } else if (props.field === "is_with_driver" && value.target.checked) {
          props.onChangeEnableForm(false);
        }
        props.onChange(value.target.checked);
      }}
    />
  );
};
